import type { FormEvent } from 'react';
import { Button } from '@azelis/ui/components/button';
import { Card, CardContent, CardFooter } from '@azelis/ui/components/card';
import { LoaderCircle, Undo2 } from 'lucide-react';

import { DocumentsStep } from './documents-step';
import { ExtraDocumentsStep } from './extra-documents-step';
import { FinishStep } from './finish-step';
import { QuestionnaireStep } from './questionnaire-step';
import { useSubmitWizard } from './submit-wizard-context';

export function WizardForm() {
  const {
    step,
    isFirst,
    isLast,
    canGoNext,
    goNext,
    goBack,
    submitting,
    handleSubmit,
  } = useSubmitWizard();

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (isLast) {
      await handleSubmit();
      return;
    }
    goNext();
  }

  return (
    <form
      className="w-full"
      onSubmit={onSubmit}
    >
      <Card className="w-full">
        <CardContent className="items-center">
          {step === 1 ? <QuestionnaireStep /> : null}
          {step === 2 ? <DocumentsStep /> : null}
          {step === 3 ? <ExtraDocumentsStep /> : null}
          {step === 4 ? <FinishStep /> : null}
        </CardContent>
        <CardFooter className="justify-between">
          <Button
            disabled={isFirst}
            size="sm"
            type="button"
            variant="outline"
            onClick={goBack}
          >
            <Undo2 data-icon="inline-start" />
            Back
          </Button>
          {isLast ? (
            <Button
              disabled={submitting}
              type="submit"
            >
              {submitting ? (
                <LoaderCircle
                  className="animate-spin"
                  data-icon="inline-start"
                />
              ) : null}
              {submitting ? 'Submitting…' : 'Submit questionnaire'}
            </Button>
          ) : (
            <Button
              disabled={!canGoNext}
              type="submit"
            >
              Next
            </Button>
          )}
        </CardFooter>
      </Card>
    </form>
  );
}
